<div class="info" *ngIf="isShowing" [@infoAnimation]>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse ultrices sem nec nulla porta faucibus. Aenean
  sed ex at velit volutpat accumsan. Sed et tortor elementum, tristique dui non, tincidunt est. Duis condimentum id
  velit sit amet aliquet. Integer nec efficitur dolor. Morbi sed purus sit amet metus sodales tristique id eget
  urna. Donec sed mi tellus. Pellentesque fermentum sem a ultrices efficitur. Vestibulum volutpat est a dui auctor,
  at volutpat massa ultrices. Sed id maximus metus. Integer tempor velit at neque ultricies, vel varius risus
  elementum. Quisque tempor dignissim magna pellentesque iaculis. Mauris tempus ligula neque. Ut at lacus.
</div>
<form *ngIf="isShowing && firstStepSignup" [@formAnimation] [formGroup]="firstStepSignup"
  (ngSubmit)="onSubmit(firstStepSignup)" ngNativeValidate class="form" #firstStepForm="ngForm">
  <h3 class="form--title">Crie sua conta</h3>
  <mat-form-field appearance="outline">
    <mat-label for="organization">Nome da organização</mat-label>
    <input matInput normalizeText type="text" id="organization" name="organization" formControlName="organization"
      required>
    <mat-hint>Somente letras e números</mat-hint>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label for="email">E-mail</mat-label>
    <input matInput type="text" id="email" name="email" formControlName="email" required>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label for="password">Senha</mat-label>
    <input matInput [type]="hidePassword ? 'password' : 'text'" id="password" name="password" formControlName="password"
      (input)="onInputPass()" required>
    <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
      [attr.aria-label]="'Esconder senha'" [attr.aria-pressed]="hidePassword">
      <mat-icon>{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
    </button>
  </mat-form-field>


  <mat-form-field appearance="outline">
    <mat-label for="confirmPassword">Confirmar senha</mat-label>
    <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" id="confirmPassword" name="confirmPassword"
      formControlName="confirmPassword" (input)="onInputPass()" required>
    <button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword"
      [attr.aria-label]="'Esconder Confirmação de Senha'" [attr.aria-pressed]="hideConfirmPassword">
      <mat-icon>{{hideConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
    </button>
    <mat-error>As senhas não correspondem</mat-error>
  </mat-form-field>

  <div class="button-container">
    <button mat-raised-button class="button button__back" type="button" routerLink="../login">Voltar</button>
    <button mat-raised-button class="button button__next" type="submit"
      [disabled]="firstStepSignup.invalid">Avançar</button>
  </div>
</form>